// extracted by mini-css-extract-plugin
export var closeButton = "_pk-2";
export var closeButtonIcon = "_pk-3";
export var lightboxContent = "_pk-1";
export var lightboxOverlay = "_pk-0";